function moneyFormat(amount, elmWithCurrencySettings) {
  var currencyPosition, currencyDelimiter, currencySeparator, currencySpace, currency, fixedtotalCost;
  var numberNewFormat, currencyNumberFormat, currencySettings;

  currency = elmWithCurrencySettings.attr("data-currency");
  if (currency == undefined) { currency = defaultCurrency() }

  if (elmWithCurrencySettings.attr("data-currency-settings") == undefined || elmWithCurrencySettings.attr("data-currency-settings") == "") {
    currencySettings = defaultCurrencySettings()
  } else {
    currencySettings = JSON.parse(elmWithCurrencySettings.attr("data-currency-settings"));
  }

  currencyPosition  = currencySettings.symbol_position;
  currencyDelimiter = currencySettings.thousands_separator;
  currencySeparator = currencySettings.decimal_mark;
  if (!currencySettings.symbol_after_without_space) {
    currencySpace = ' '
  } else {
    currencySpace = ''
  };

  fixedtotalCost  = parseFloat(amount).toFixed(2).replace(".", currencySeparator);
  numberNewFormat = fixedtotalCost.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1"+ currencyDelimiter);

  if (elmWithCurrencySettings.data('currency-code') != undefined) {
    currency = elmWithCurrencySettings.data('currency-code') == 'symbol' ? currency : ` ${currency} `
  }

  if (currencyPosition == 'after') {
    currencyNumberFormat = numberNewFormat + currencySpace + currency
  } else {
    currencyNumberFormat = currency + currencySpace + numberNewFormat
  };

  return currencyNumberFormat
};

function defaultCurrencySettings() {
  return { symbol_position: "before", thousands_separator: ",", decimal_mark: ".", symbol_after_without_space: false }
}

function defaultCurrency() {
  return ''
}

export default moneyFormat
